<template>
  <div class="content">
    <div class="border-card">
      <!-- <div
        class="pat-card"
        v-for="(item,index) in patList"
        :key="index"
        @click="$router.push('/patient_edit?id='+item.id+'&from=patient_list')"
      >-->
      <div
        class="pat-card patient-box"
        v-for="(item,index) in patList"
        :key="index"
        @click="$router.push('/patient_detail?id='+item.id)"
      >
        <p class="font-85">{{item.realname}}</p>
        <p class="pat-ages font-65">
          <i class="icon icon-pat-male" :class="{'icon-pat-female':item.sex==2}"></i>
          {{item.sex==1?'男':'女'}} {{item.age}}岁
        </p>
      </div>
      <div class="pat-card add-card" v-if="patList.length<6" @click="addPat">
        <i class="icon icon-pat-add"></i>
        <p class="pat-ages">添加就诊人</p>
      </div>
      <br class="clear" />
    </div>
  </div>
</template>

<script>
import http from "../../request/http";

export default {
  name: "patient_list",
  data() {
    return {
      patList: [],
      patid: 0,
    };
  },
  methods: {
    patientlist() {
      http.post("/api/wap/user/patientlist").then((res) => {
        this.patList = res.data;
        this.patid = res.data[0].id;
      });
    },
    addPat() {
      this.$router.push({
        name: "patient_edit",
        query: {
          from: "patient_list",
        },
      });
    },
  },
  mounted() {
    this.patientlist();
  },
};
</script>

<style scoped>
@import "./patient.css";
.content {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fafafa;
}
.content .pat-card {
  float: left;
}
.pat-card:nth-child(2n) {
  margin-left: 0.95rem;
}
.patient-box {
  padding: 0.8rem 1rem;
  box-sizing: border-box;
}
.patient-box p {
  height: 1.4rem;
  line-height: 1.4rem;
  font-size: 1rem;
  margin-bottom: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.patient-box .pat-ages,.add-card .pat-ages {
  height: 1.2rem;
  line-height: 1.2rem;
  margin-bottom: 0;
}
.add-card{
  padding: 0.8rem;
  box-sizing: border-box;
}
.icon-pat-add{
  vertical-align: top;
}
.pat-card{
  width: calc(50vw - 2rem);
}
</style>



// WEBPACK FOOTER //
// src/pages/patient/patient_list.vue